// extracted by mini-css-extract-plugin
export default {"navigationHeader":"NavigationHeader_navigationHeader__-OFHo"};